module.exports = __webpack_public_path__ + "static/may-2-aea238a5e935f19de2029577250cb7c2.png";